module.exports = __webpack_public_path__ + "assets/img/Type E (67).7d505f31.jpg";